import request from './request';

export function getMyTreasures() {
  return request.get('/api/treasure/myTreasures');
}

export function openTreasure(roomId) {
  return request.post('/api/treasure/openTreasure', { room_id: roomId });
}
export function getTreasureStatus() {
  return request.get('/api/treasure/treasureStatus');
}
